<!-- TODO NEED OPTIMIZATION; MY-PROFILE AND PROFILE HAS SIMILAR CODE -->
<template>
    <section class="my-profile">
      <div class="title-container">
        <h1 class="title">
          {{ editProfile.form.name.value }}
          <div
            v-if="isLoading" class="spinner-border spinner-theme_default"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </h1>
        <div class="title-container__controls">
          <b-button
            class="button title-container__controls-item"
            variant="outline"
            @click="setVisiblePasswordModal(true)"
          >
            Change password
          </b-button>
          <b-button
            class="button"
            variant="primary"
            @click="setVisibleEditModal(true)"
          >
            Edit Profile
          </b-button>
        </div>
      </div>

      <b-modal
        v-model="changePassword.showModal"
        size="md"
        :style="{ zIndex: 200 }"
        no-close-on-backdrop
      >
        <template  v-slot:modal-header="{ cancel }">
          <h5 class="modal-title">Change Password</h5>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click.prevent="cancel"
          >
          <span class="material-icons">
            close
          </span>
          </button>
        </template>
        <FormGenerator
          :data="changePassword.form"
          :showFormControls="false"
          @submit="updatePassword"
          ref="changePasswordForm"
        >
        </FormGenerator>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            variant="outline"
            class="button"
            @click.prevent="cancel"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="button"
            @click.prevent="submitPasswordFormModal"
          >
            Save changes
          </b-button>
        </template>
      </b-modal>
      <b-modal
        v-model="editProfile.showModal"
        size="md"
        :style="{ zIndex: 200 }"
        no-close-on-backdrop
      >
        <template  v-slot:modal-header="{ cancel }">
          <h5 class="modal-title">Edit Profile</h5>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click.prevent="cancel"
          >
          <span class="material-icons">
            close
          </span>
          </button>
        </template>
        <FormGenerator
          :data="editProfile.form"
          :showFormControls="false"
          @submit="updateProfile"
          ref="form"
        >
        </FormGenerator>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            variant="outline"
            class="button"
            @click.prevent="cancel"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="button"
            @click.prevent="submitModal"
          >
            Save changes
          </b-button>
        </template>
      </b-modal>

      <div class="row">
        <div class="col-6">
          <div
            class="table__theme-default table__none-hover"
            v-if="table.items.length"
          >
            <div class="table-container pb-0">
              <b-table
                primary-key="id"
                :fields="table.fields"
                :items="table.items"
                style="margin-bottom: 0;"
                fixed
              >
                <template v-slot:cell(avatar)="data">
                  <b-img
                    v-if="data.item.avatar"
                    :src="data.item.avatar"
                    rounded="circle"
                    alt="Circle image"
                    class="user-profile-avatar"
                  />
                  <b-img
                    v-else
                    v-bind="mainProps"
                    rounded="circle"
                    alt="Circle image"
                    class="user-profile-avatar"
                  />
                </template>
                <template v-slot:cell(actions)="data">

                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="col-6">
          <user-skills v-if="$can('read_own-skills')"></user-skills>
        </div>
      </div>
    </section>
</template>

<script>
import UserSkills from './UserSkills'
import FormGenerator from '@components/FormGenerator'

export default {
  name: 'MyProfile',
  components: { UserSkills, FormGenerator },
  data () {
    return {
      editProfile: {
        showModal: false,
        form: {
          'name': {
            type: 'input',
            name: 'name',
            label: 'Name',
            placeholder: 'Name',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'position': {
            type: 'input',
            name: 'position',
            label: 'Position',
            placeholder: 'Position',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          }
        }
      },
      changePassword: {
        showModal: false,
        form: {
          'enter_password': {
            type: 'input',
            name: 'old_password',
            label: 'Enter password',
            placeholder: 'password',
            typeInput: 'password',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'enter_new_password': {
            type: 'input',
            name: 'new_password',
            label: 'Enter new password',
            placeholder: 'password',
            typeInput: 'password',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          },
          'enter_new_password_again': {
            type: 'input',
            name: 'password',
            label: 'Enter new password again',
            placeholder: 'password',
            typeInput: 'password',
            validation: [
              { name: 'required' }
            ],
            value: null,
            class: 'col-12'
          }
        }
      },
      table: {
        items: [],
        fields: [
          {
            key: 'avatar',
            label: 'Avatar',
            class: 'column-avatar'
          },
          {
            key: 'name',
            label: 'Name'
          },
          {
            key: 'position',
            label: 'Position'
          }
        ]
      },

      userAvatar: null,
      userName: '',
      userPosition: '',
      userOldPassword: '',
      userPassword: '',
      userNewPassword: '',

      updatedData: {
        name: '',
        position: '',
        password: '',
        old_password: '',
        new_password: ''
      },
      mainProps: { blank: true, blankColor: '#777', width: 75, height: 75, class: 'm1' },

      collapsed: false,
      isLoading: false
    }
  },
  mounted () {
    this.userId = this.$route.params.id
    this.isLoading = true
    this.axios({
      method: 'get',
      url: `/api/authUser`,
      headers: {
        Authorization: 'Bearer' + localStorage.getItem('access_token')
      }
    }).then(response => {
      this.userAvatar = response.data.avatar
      this.userName = response.data.name
      this.userPosition = response.data.position

      this.editProfile.form.name.value = response.data.name
      this.editProfile.form.position.value = response.data.position

      this.table.items = [response.data]
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      this.isLoading = false
    })
  },
  methods: {
    updateProfile (data) {
      const formData = this.prepareDataForRequest(data)

      this.setVisibleEditModal(false)
      this.updateProfileRequest(formData)
    },
    updatePassword (data) {
      const formData = {
        ...this.prepareDataForRequest(this.editProfile.form),
        ...this.prepareDataForRequest(data)
      }

      this.setVisiblePasswordModal(false)
      this.updateProfileRequest(formData)
    },
    prepareDataForRequest (fields) {
      let data = {}

      for (let key in fields) {
        const field = fields[key]
        const fieldName = field['name']
        const fieldValue = fields[key]['value']

        data[fieldName] = fieldValue
      }

      return data
    },
    submitModal () {
      this.$refs.form.submit()
    },
    submitPasswordFormModal () {
      this.$refs.changePasswordForm.submit()
    },
    setVisibleEditModal (status) {
      this.editProfile.showModal = status
    },
    setVisiblePasswordModal (status) {
      this.changePassword.showModal = status
    },
    /* TODO NEED OPTIMIZATION */
    updateProfileRequest (data) {
      this.isLoading = true
      this.axios.put(
        `/api/update/profile`,
        data,
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(response => {
        if (response.status === 200) {
          this.userOldPassword = ''
          this.userPassword = ''
          this.userNewPassword = ''
          this.$snotify.success('Profile succesfully updated', 'Success', this.$store.state.snotify)
          this.collapsed = false
          this.editProfile.form.name.value = response.data.name
          this.editProfile.form.position.value = response.data.position

          this.$store.dispatch('setUser', response.data)
        }

        this.updatedData = {}
      }).catch(err => {
        console.log(err.response)
        // this.$snotify.error(err.response.data.message, "Error", this.$store.state.snotify);
        if (err.response.data.errors) {
          var errors = Object.values(err.response.data.errors)
          console.log(errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
          }
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    updateUser (e) {
      e.preventDefault()
      this.updatedData = {
        name: '',
        position: '',
        password: '',
        old_password: '',
        new_password: ''
      }
      this.updatedData.name = this.userName
      this.updatedData.position = this.userPosition

      if (this.userOldPassword.length || this.userPassword.length || this.userNewPassword) {
        if (this.userPassword.length >= 1 && this.userPassword.length <= 10) {
          this.updatedData.password = this.userPassword
        } else {
          this.$snotify.error('The password value is not between 1 - 10.', 'Error', this.$store.state.snotify)
        }
        if (this.userNewPassword === this.userPassword) {
          this.updatedData.new_password = this.userNewPassword
        } else {
          this.$snotify.error('The new passwords must match.', 'Error', this.$store.state.snotify)
        }
        if (this.userOldPassword.length) {
          this.updatedData.old_password = this.userOldPassword
        } else {
          this.$snotify.error('Current password is required when changing password', 'Error', this.$store.state.snotify)
        }
        if (this.updatedData.old_password.length && this.updatedData.password.length && this.updatedData.new_password.length) {
          this.updateProfile()
        }
      } else {
        this.updateProfile()
      }
    }
  }
}
</script>

<style>
  .user-profile {
    max-width: 600px;
    margin: 1.5rem auto;
    padding: 40px;
    box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
  }

  .user-profile-avatar {
    display: block;
    width: 33px;
    height: 33px;
  }

  .column-avatar{
    width: 60px;
  }
</style>
